export const CPS_FIELD_TYPE = {
  TEXT: 'text',
  NUMERIC: 'numeric',
  INT32: 'int',
  INT64: 'int64',
  BOOLEAN: 'boolean',
  DATE: 'date',
  DATETIME: 'datetime',
  MULTICHOICE: 'multichoice',
  LINK: 'link'
} as const;

export type CpsFieldType = (typeof CPS_FIELD_TYPE)[keyof typeof CPS_FIELD_TYPE];

type CpsFieldUnionType = 'boolean' | 'text' | 'numeric' | 'date';

export const CpsFieldTypeToFilterType = (fieldType: CpsFieldType): CpsFieldUnionType => {
  if (fieldType.toLowerCase() === CPS_FIELD_TYPE.DATETIME.toLowerCase()) {
    return CPS_FIELD_TYPE.DATE;
  } else if (
    fieldType.toLowerCase() === CPS_FIELD_TYPE.INT32.toLowerCase() ||
    fieldType.toLowerCase() === CPS_FIELD_TYPE.INT64.toLowerCase()
  ) {
    return CPS_FIELD_TYPE.NUMERIC;
  } else if (
    fieldType.toLowerCase() === CPS_FIELD_TYPE.MULTICHOICE ||
    fieldType.toLowerCase() === CPS_FIELD_TYPE.LINK
  ) {
    return CPS_FIELD_TYPE.TEXT;
  } else {
    return fieldType as CpsFieldUnionType;
  }
};
